import { render, staticRenderFns } from "./medicalNews.vue?vue&type=template&id=8c601a00&scoped=true&"
import script from "./medicalNews.vue?vue&type=script&lang=js&"
export * from "./medicalNews.vue?vue&type=script&lang=js&"
import style0 from "./medicalNews.vue?vue&type=style&index=0&id=8c601a00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c601a00",
  null
  
)

export default component.exports